module.exports = __webpack_public_path__ + "static/media/1 Collar.bbf0a5c4.jpg";